/* Nature's Paw — allergy PDP behaviour. Scoped to .npa; fails silent if a block is absent. */
(function () {
  'use strict';

  /* 2 · before / after drag slider */
  function initBA() {
    var range = document.getElementById('ba-range');
    if (!range) return;
    var before = document.getElementById('ba-before');
    var handle = document.getElementById('ba-handle');
    var seam = document.getElementById('ba-seam');
    function set(v) {
      if (before) before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      if (handle) handle.style.left = v + '%';
      if (seam) seam.style.left = v + '%';
    }
    range.addEventListener('input', function () { set(this.value); });
    set(range.value);
  }

  /* 3 · ships by next calendar day */
  function initShips() {
    var el = document.getElementById('shipdate');
    if (!el) return;
    var d = new Date();
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* 4 · mirror the bundle the shopper picked into the price row and the ATC label.
        Ka-Ching owns the selector, so this reads whatever it renders and only acts
        when it can parse a price with confidence. Silent no-op otherwise. */
  function initPriceSync() {
    var now = document.getElementById('npa-price-now');
    var was = document.getElementById('npa-price-was');
    if (!now) return;
    var row = now.closest('.pricerow');
    var revealed = false;

    /* The selected Ka-Ching bar. Only real deal bars carry data-deal-bar-id; the
       subscription toggle row shares the bar class but is not a deal. */
    function selectedBar() {
      var bars = document.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]');
      if (!bars.length) bars = document.querySelectorAll('.kaching-bundles__bar');
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].classList.contains('kaching-bundles__bar--selected')) return bars[i];
      }
      for (var j = 0; j < bars.length; j++) {
        var r = bars[j].querySelector('input[type="radio"]');
        if (r && r.checked) return bars[j];
      }
      return null;
    }

    function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

    function reveal() {
      revealed = true;
      if (row) row.classList.remove('npa-price-pending');
    }

    /* Mirror Ka-Ching's own rendered figures for the selected bar. They are already in
       the shopper's market currency and already reflect the subscription toggle, so we
       copy them verbatim. Never regex the bar's loose text: the "$19.99 per bottle"
       subtitle is a hard-coded USD string and used to win that match in non-USD markets. */
    function sync() {
      var bar = selectedBar();
      if (!bar) return;
      var price = text(bar.querySelector('.kaching-bundles__bar-price'));
      var full = text(bar.querySelector('.kaching-bundles__bar-full-price'));
      if (!price) return;
      if (now.textContent !== price) now.textContent = price;
      if (was) {
        if (full && full !== price) {
          if (was.textContent !== full) was.textContent = full;
          was.style.display = '';
        } else {
          was.style.display = 'none';
        }
      }
      if (!revealed) reveal();
      paintButton();
    }

    function paintButton() {
      var btn = document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]');
      if (!btn) return;
      var host = btn.querySelector('.wt-btn__label span') || btn.querySelector('.wt-btn__label') || btn;
      // Ka-Ching injects the price as loose text; strip any $-amount text nodes
      var walk = host.childNodes;
      for (var i = walk.length - 1; i >= 0; i--) {
        var n = walk[i];
        if (n.nodeType === 3 && /\$\s?\d/.test(n.textContent)) n.textContent = n.textContent.replace(/[–-]?\s*\$\s?\d[\d,]*(?:\.\d{2})?/g, '');
        if (n.nodeType === 1 && n.classList && n.classList.contains('npa-atc-price')) n.remove();
      }
      if (!btn.querySelector('.npa-atc-sub')) {
        var sub = document.createElement('span');
        sub.className = 'npa-atc-sub';
        sub.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8.8 12l2.2 2.2 4-4.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>60-Day Money-Back Guarantee';
        host.appendChild(sub);
      }
    }

    /* guarantee line under the cart drawer's checkout button */
    function paintCartGuarantee() {
      var cos = document.querySelectorAll('button[name="checkout"], [name="checkout"], a[href="/checkout"]');
      for (var i = 0; i < cos.length; i++) {
        var co = cos[i];
        if (!co.parentElement) continue;
        if (co.nextElementSibling && co.nextElementSibling.classList && co.nextElementSibling.classList.contains('npa-cart-guarantee')) continue;
        var p = document.createElement('p');
        p.className = 'npa-cart-guarantee';
        p.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8.8 12l2.2 2.2 4-4.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>60-Day Money-Back Guarantee';
        co.insertAdjacentElement('afterend', p);
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[class*="kaching"]')) { setTimeout(sync, 120); setTimeout(sync, 500); }
    }, { passive: true });
    document.addEventListener('kaching-bundles-initialized', function () { sync(); setTimeout(sync, 300); });
    // Ka-Ching writes its own price into the button on load, so re-assert ours
    // a few times until the DOM settles. Cheap, and it stops the anchor vanishing.
    [600, 1400, 2600, 4200].forEach(function (ms) { setTimeout(sync, ms); setTimeout(paintCartGuarantee, ms); });
    // If Ka-Ching never renders (blocked, slow, or removed) show the variant price
    // the template rendered rather than leaving the slot blank.
    setTimeout(function () { if (!revealed) reveal(); }, 2500);
    if (window.MutationObserver) {
      var queued = false;
      var touchesKaching = function (m) {
        var el = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
        return !!(el && el.closest && el.closest('.kaching-bundles__block, kaching-bundle, [class*="kaching-bundles"]'));
      };
      new MutationObserver(function (muts) {
        paintButton(); paintCartGuarantee();
        for (var i = 0; i < muts.length; i++) {
          if (touchesKaching(muts[i])) {
            if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; sync(); }); }
            break;
          }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  /* 5 · Badge colours now come from Ka-Ching's own Custom Styles (set 2026-09-11); the JS repaint was removed. */

  /* 6 · review carousel dots track the scroll-snap position and jump on tap */
  function initReviewDots() {
    var slider = document.querySelector('.npa .slider');
    var dotsWrap = document.querySelector('.npa .sliderdots');
    if (!slider || !dotsWrap) return;
    var cards = slider.querySelectorAll('.rcard');
    var dots = dotsWrap.querySelectorAll('i');
    if (!cards.length || !dots.length) return;

    function paint(idx) {
      for (var i = 0; i < dots.length; i++) dots[i].className = i === idx ? 'on' : '';
    }
    function current() {
      var mid = slider.scrollLeft + slider.clientWidth / 2;
      var idx = 0;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.offsetLeft <= mid) idx = i;
      }
      return Math.min(idx, dots.length - 1);
    }

    var raf = null;
    slider.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; paint(current()); });
    }, { passive: true });

    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          var card = cards[Math.min(idx, cards.length - 1)];
          if (card) slider.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        });
      })(i);
    }
    paint(current());
  }

  /* 7 · sticky buy bar: only appears once the shopper has scrolled past the real
        ATC button, and clicking it scrolls back to the buy box (bundle picker)
        instead of adding to the cart. CSS hides the bar until .npa-sticky-show. */
  function initStickyGate() {
    var atc = document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]');
    if (!atc) return;

    function findSticky() { return document.querySelector('.wt-product__sticky-buy'); }

    /* eased scroll: the native smooth behaviour jumps too fast over a long page */
    function glideTo(el) {
      var targetY = el.getBoundingClientRect().top + window.pageYOffset - Math.max(0, (window.innerHeight - el.offsetHeight) / 2);
      targetY = Math.max(0, targetY);
      var startY = window.pageYOffset;
      var dist = targetY - startY;
      if (!dist) return;
      var duration = Math.min(1400, Math.max(700, Math.abs(dist) * 0.35));
      var t0 = null;
      function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / duration);
        window.scrollTo(0, startY + dist * ease(p));
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function update() {
      var sticky = findSticky();
      if (!sticky) return;
      var past = atc.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('npa-sticky-show', past);
    }

    function wire(sticky) {
      if (!sticky || sticky.dataset.npaWired) return;
      sticky.dataset.npaWired = '1';
      // capture phase so the theme's own add-to-cart handler never runs
      sticky.addEventListener('click', function (e) {
        var btn = e.target.closest('button, [name="add"], a');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var target = document.querySelector('.wt-product__info .shopify-app-block') || atc;
        glideTo(target);
      }, true);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    var tries = 0;
    var t = setInterval(function () {
      var sticky = findSticky();
      if (sticky) { wire(sticky); update(); clearInterval(t); }
      else if (++tries > 40) clearInterval(t);
    }, 250);
    wire(findSticky());
    update();
  }

  function boot() { initBA(); initShips(); initPriceSync();
initReviewDots(); initStickyGate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* r7 price-anchor fix */
